import React, { useEffect } from 'react';

import { OBSERVABILITY_MY_DAY_TODAY } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { EventTypeLabel } from 'src/myDayToday/components/EventSubType';
import { useScheduledEventCardStyles } from 'src/myDayToday/components/ScheduledEventCard.styles';
import { ScheduledEventCardHeader } from 'src/myDayToday/components/ScheduledEventCardHeader';
import { VisitTimeFrame } from 'src/myDayToday/components/VisitTimeFrame';
import { getScheduledEventTiming } from 'src/myDayToday/components/getScheduledEventTiming';
import { useProviderId } from 'src/myDayToday/domain/useProviderId';
import { useObservability } from 'src/observability/useObservability';

type PartialEvent = {
  duration: number;
  start: Date;
  subType: string;
  title?: string | null;
};

type NonPatientEventCardProps = {
  currentTime: Date;
  event: PartialEvent;
};

const NonPatientEventCard = (props: NonPatientEventCardProps) => {
  const classes = useScheduledEventCardStyles();

  const enableObservability = useFeatureFlag(OBSERVABILITY_MY_DAY_TODAY);
  const sendStaffEvent = useObservability(enableObservability);
  const providerId = useProviderId();

  const eventTiming = getScheduledEventTiming(props.currentTime, props.event.start);

  const containerClasses = [classes.container, eventTiming];

  useEffect(() => {
    sendStaffEvent({
      eventType: 'myDayToday:scheduledBlockedTimeCardViewed',
      userId: providerId ?? null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={containerClasses.join(' ')} data-testid="scheduled-non-patient-event-card">
      <div className="header">
        <ScheduledEventCardHeader
          currentTime={props.currentTime}
          start={props.event.start}
          timing={eventTiming}
        />
      </div>
      <div className="body">
        <div className="details">
          <div className="nonPatientEventType">
            <EventTypeLabel subType={props.event.subType} />
          </div>
          <div className="nonPatientEventTitle">{props.event.title}</div>
          <div className="visitTimeFrame">
            <VisitTimeFrame start={props.event.start} duration={props.event.duration} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NonPatientEventCard;
